import { LitElement, html, nothing } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import {
    MetaData,
    ReportField,
    ReportFieldsStructure,
    ReportValues,
    ScheduleItem,
    ShowMinimizePopUp,
} from '../type/modal-for-report-type'
import {
    CoordinateConverterReports,
    ModalStylesForReports,
    NoData,
    getParsedValue,
    getWindBF,
    isRequired,
    latitudeRegex,
    longitudeRegex,
    validations,
} from '../utils/modal-for-reports-utils'
import { dropdownOptions } from './dropdown-options'
import { SvgIcons } from '../../voyage-svg-icons/src/voyage-svg-icons'
import '../../voyage-spinner/src/voyage-spinner'
import { WeatherRoutingModel } from '../../../src/models/weather-routing-reports-model'
import { SchedulesService } from '../../../src/services/schedules-service'
import { TerminalsModel } from '../../../src/models/terminals-model'
import { CoordinatesUtils } from '../../../src/utils/coordinates-utils'
import { SHOW_MINIMIZED_REPORT, SHOW_WNI_REPORT_POPUP } from '../../../src/models/weather-routing-reports-model-impl'
import { VesselAlertsModel } from '../../../src/models/vessel-alerts-model'
import { VoyageDialogPopupManager } from '../../voyage-dialog-popup/src/voyage-dialog-popup-manager'
import { FeatureFlagModel, FeatureFlagsEvents } from '../../../src/models/feature-flag-model'
type MetaDataKeys = keyof MetaData
@customElement('modal-for-reports')
export class ModalForReports extends LitElement {
    @property({ type: Boolean }) open = false
    @property({ type: Boolean }) canCreateNoonReport = false
    @property({ type: Object }) fields: ReportFieldsStructure = {}
    @property({ type: Object }) fieldValues: ReportValues = {} as ReportValues
    @property({ type: String, attribute: true }) activeTab = ''
    @property({ attribute: false }) private _isValid: boolean = false
    @property({ type: Boolean }) private _isLoading: boolean = true
    @property({ type: Object }) _fieldValues: { [key: string]: any } = {}
    @property({ attribute: false }) private paginationIds: number[] = []
    private dropdownforReports: { [key: string]: any } = dropdownOptions
    @property({ attribute: false }) currentPage = 1
    @property({ attribute: false }) errorOrEmpty: any = false
    @property({ attribute: false }) disableValues: any = false
    @property({ attribute: false }) errorLatLon: boolean = false
    @property({ attribute: true }) showMinimizePopUp: ShowMinimizePopUp = {
        minimizedPopUp: true,
        reportType: '',
        scheduleId: '',
        reportId: '' as string,
    }
    @property({ attribute: true }) openPopUp: boolean = false

    constructor() {
        super();

        this._updateInitialTab = this._updateInitialTab.bind(this);
        this._onFeatureFlagsUpdated = this._onFeatureFlagsUpdated.bind(this);
    }

    static styles = [ModalStylesForReports]

    connectedCallback(): void {
        super.connectedCallback()
        this._setupEventListeners();
        FeatureFlagModel?.addEventListener('featureFlagsUpdated', this._onFeatureFlagsUpdated);
        window.addEventListener(FeatureFlagsEvents.featureBasedFlagsInitialized, (e: Event) => {
            const custom = (e as CustomEvent).detail;
            if (custom.weatherRoutingEnabled) {
                const readyModel = WeatherRoutingModel;
                readyModel?.addEventListener(SHOW_WNI_REPORT_POPUP, this._updateInitialTab);
            }
        });
    }


    disconnectedCallback(): void {
        super.disconnectedCallback()
        this._cleanupEventListeners();
        FeatureFlagModel?.removeEventListener('featureFlagsUpdated', this._onFeatureFlagsUpdated);
    }

    private _setupEventListeners() {
        WeatherRoutingModel?.addEventListener(SHOW_WNI_REPORT_POPUP, this._updateInitialTab);
    }

    private _cleanupEventListeners() {
        WeatherRoutingModel?.removeEventListener(SHOW_WNI_REPORT_POPUP, this._updateInitialTab);
    }

    private _onFeatureFlagsUpdated() {
        // Re-setup listeners in case models were just initialized
        this._setupEventListeners();
    }

    private _updateInitialTab(e: Event) {
        const { reportType } = (e as CustomEvent).detail;
        
        const tabMap: Record<string, string> = {
            Departure: 'sosp',
            Arrival: 'eosp',
            Noon: 'noon',
          };
      
          const activeTab = tabMap[reportType];

        if (activeTab) {
            this.activeTab = activeTab;
            this.open = true;
            // this.requestUpdate();
            // this._switchTab(activeTab);
        }
    }

    updated(changedProperties: Map<string | symbol, unknown>): void {
        super.updated(changedProperties)
        if (changedProperties.has('paginationIds')) {
            this.currentPage = 1
        }
        if (
            changedProperties.has('fields') ||
            changedProperties.has('fieldValues')
        ) {
            this._isLoading = true
            this._initializeFieldValues()
        }
    }

    private _getFormattedValue(item: ReportField): string | number {
        if (!this.fieldValues.metadata) {
            return ''
        }

        const rawValue =
            this.fieldValues?.metadata[item.fieldName as MetaDataKeys]?.value ??
            ''
        switch (item.type) {
            case 'date':
                return String(rawValue).substring(0, 16)
            default:
                return typeof rawValue === 'number'
                    ? rawValue
                    : String(rawValue)
        }
    }

    private _initializeFieldValues() {
        if (
            Object.entries(this.fields).length === 0 ||
            Object.entries(this.fieldValues).length === 0
        ) {
            this._isLoading = true
            return
        }
        this._isLoading = true
        try {
            Object.entries(this.fields['tab1']).map(([_, fields]) => {
                fields?.map((item) => {
                    if (this.fieldValues.status === 'closed' || this.fieldValues.status === 'submitted') {
                        this.disableValues = true
                    } else {
                        this.disableValues = false
                    }
                    let latOrLon =
                        item.fieldName === 'lat' || item.fieldName === 'lon' || item.fieldName === 'arr_ps_lat' || item.fieldName === 'arr_ps_lon'
                    if (item.fieldName === 'wind_speed') {
                        if (!this.fieldValues.metadata) {
                            return ''
                        }
                        this._fieldValues[item.fieldName] = {
                            value:
                                this.fieldValues?.metadata[
                                    item.fieldName as MetaDataKeys
                                ]?.value ?? 0,
                            invalid: false,
                            change: this.fieldValues?.metadata[
                                item.fieldName as MetaDataKeys
                            ]?.value
                                ? false
                                : true,
                            required: item.required,
                            errorMessage: '',
                            formattedValue: '',
                        }
                    } else if (item.fieldName === 'wind_bf') {
                        if (!this.fieldValues.metadata) {
                            return ''
                        }
                        if (this.fieldValues.metadata['wind_bf']) {
                            this.fieldValues.metadata[
                                'wind_bf'
                            ].isSystemGenerated = true
                        }
                        this._fieldValues[item.fieldName] = {
                            value: getWindBF(
                                this.fieldValues?.metadata['wind_speed']
                                    ?.value ?? 0,
                            ),
                            invalid: false,
                            change: true,
                            required: item.required,
                            errorMessage: '',
                        }
                    } else {
                        this._fieldValues[item.fieldName] = {
                            value: this.fieldValues.metadata
                                ? this._getFormattedValue(item)
                                : '',
                            invalid: this._handleInvalid(item),
                            change: false,
                            required: item.required,
                            errorMessage: '',
                            formattedValue:
                                this.fieldValues.metadata && latOrLon
                                    ? this._formatCoordinate(
                                          this._getFormattedValue(
                                              item,
                                          ) as number,
                                          item?.fieldName === 'lat' || item.fieldName === 'arr_ps_lat',
                                      )
                                    : '',
                        }
                    }
                })
            })
            this._isLoading = false
        } catch (e) {
            this._isLoading = false
        }
    }

    //  EOSP : Arrival Report
    private async eospReportSubmit(payload: object) {
        try {
            this._isLoading = true
            const responseArrivalReport =
                await WeatherRoutingModel?.arrivalReportSubmit(payload)
            if (responseArrivalReport?.isSuccess === true) {
                this._handleCloseReportSubmit()
            } else {
                this._isLoading = false
            }
        } catch (err) {
            console.warn(err, 'err')
        }
    }

    private async eospReportPUT(payload: ReportValues) {
        this._isLoading = true
        try {
            const responseArrivalReport =
                await WeatherRoutingModel?.arrivalReportPut(payload)
            if (responseArrivalReport?.isSuccess === true) {
                this._handleClose()
                const scheduleId = payload.schedule_id;
                this.handleCloseActiveNotification(scheduleId, 'Arrival');
            } else {
                this._isLoading = false
            }
        } catch (err) {
            this._isLoading = false
            console.warn(err, 'err')
        }
    }

    handleCloseActiveNotification(scheduleId: string, reportType: string) {
        const existingWniNotifications = localStorage.getItem('WNIReportsNotifications');
        if (existingWniNotifications) {
            const parsedNotifications = JSON.parse(existingWniNotifications);
            const currentScheduleNotifications = parsedNotifications[scheduleId];
            const NotificationId = currentScheduleNotifications[reportType];
            if(NotificationId) {
                VesselAlertsModel!.removeAlert((<any>window)["appenv"].vesselIMONumber, NotificationId);

                const newScheduleNotifications = {
                    ...currentScheduleNotifications,
                    [reportType]: ''
                }

                const newNotifications = {
                    ...parsedNotifications,
                    [scheduleId]: newScheduleNotifications
                }

                localStorage.setItem('WNIReportsNotifications', JSON.stringify(newNotifications));
            }

        }
    }

    //  SOSP : Departure Report
    private async sospReportSubmit(payload: ReportValues) {
        try {
            this._isLoading = true
            const responseDepartureReport =
                await WeatherRoutingModel?.departureReportSubmit(payload)
            if (responseDepartureReport?.isSuccess) {
                this._handleCloseReportSubmit();
                const scheduleId = payload.schedule_id;
                this.handleCloseActiveNotification(scheduleId, 'Departure');
            } else {
                this._isLoading = false
            }
        } catch (err) {
            this._isLoading = false
            console.warn(err, 'err')
        }
    }

    private async sospReportPUT(payload: object) {
        this._isLoading = true
        try {
            const responseArrivalReport =
                await WeatherRoutingModel?.departureReportPut(payload)
            if (responseArrivalReport?.isSuccess === true) {
                this._handleClose()
            } else {
                this._isLoading = false
            }
        } catch (err) {
            this._isLoading = false
            console.log(err, 'err')
        }
    }

    private async noonReportSubmit(payload: ReportValues) {
        this._isLoading = true
        try {
            const responseNoonReport =
                await WeatherRoutingModel?.noonReportSubmit(payload)
            if (responseNoonReport?.isSuccess ) {
                this._handleCloseReportSubmit()
                const scheduleId = payload.schedule_id;
                this.handleCloseActiveNotification(scheduleId, 'Noon');
            } else {
                this._isLoading = false
            }
        } catch (err) {
            this._isLoading = false
            console.warn(err, 'err')
        }
    }

    private async noonReportPUT(payload: object) {
        this._isLoading = true
        try {
            const responseNoonReport = await WeatherRoutingModel?.noonReportPut(
                payload,
            )
            if (responseNoonReport?.isSuccess === true) {
                this._handleClose()
            } else {
                this._isLoading = false
            }
        } catch (err) {
            this._isLoading = false
            console.warn(err, 'err')
        }
    }

    private async _handleSubmitAndSave(saveOrSubmit: boolean) {
        for (const [_, value] of Object.entries(this._fieldValues)) {
            const emptyValue = value === '' || value === null
            if (this._fieldValues.required && emptyValue) {
                this._isValid = true
                return
            }
        }
        for (const key in this._fieldValues) {
            if (this.fieldValues.metadata) {
                const ifChanged = this._fieldValues[key].change === true
                const metaKey = key as MetaDataKeys
                const rawValue = this._fieldValues[key].value
                const processedValue = typeof rawValue === 'string' ? rawValue.replace(/,/g, '.') : rawValue
                ;(this.fieldValues.metadata as any)[metaKey] = ifChanged
                    ? {
                          value: processedValue,
                          isSystemGenerated:
                              this.fieldValues?.metadata[metaKey]
                                  ?.isSystemGenerated,
                      }
                    : this.fieldValues?.metadata[metaKey]
            }
        }
        const reportFunctionMap: { [key: string]: () => Promise<void> } = {
            eosp: async () => {
                if (saveOrSubmit) {
                    const EospReportSubmit = VoyageDialogPopupManager.createDialog({
                        headerText: 'Submit Eosp Report',
                        bodyText: 'Are you sure want to submit the Report, by submitting the EOSP Report\n you will end Weather Routing for current voyage',
                        acceptButtonText: 'Submit',
                        rejectButtonText: 'Cancel'
                    })

                    const response = await EospReportSubmit.getResponse();

                    if(response == 'accept') {
                        this.fieldValues.status = 'submitted'
                        await this.eospReportSubmit(this.fieldValues)
                    }
                } else {
                    await this.eospReportPUT(this.fieldValues)
                }
            },
            sosp: async () => {
                if (saveOrSubmit) {
                    const SospReportSubmit = VoyageDialogPopupManager.createDialog({
                        headerText: 'Submit Sosp Report',
                        bodyText: 'Are you sure want to submit the Report',
                        acceptButtonText: 'Submit',
                        rejectButtonText: 'Cancel'
                    })

                    const response = await SospReportSubmit.getResponse();

                    if(response == 'accept') {
                        this.fieldValues.status = 'submitted'
                        await this.sospReportSubmit(this.fieldValues)
                    }
                } else {
                    await this.sospReportPUT(this.fieldValues)
                }
            },
            noon: async () => {
                if (saveOrSubmit) {
                    const NoonReportSubmit = VoyageDialogPopupManager.createDialog({
                        headerText: 'Submit Noon Report',
                        bodyText: 'Are you sure want to submit the Report',
                        acceptButtonText: 'Submit',
                        rejectButtonText: 'Cancel'
                    })

                    const response = await NoonReportSubmit.getResponse();

                    if(response == 'accept') {
                        this.fieldValues.status = 'submitted'
                        await this.noonReportSubmit(this.fieldValues)
                    }
                } else {
                    await this.noonReportPUT(this.fieldValues)
                }
            },
        }
        try {
            await reportFunctionMap[this.activeTab]?.()
        } catch (e) {
            console.log(e, 'e')
        }
    }

    private _handleClose() {
        this._fieldValues = {}
        this.fieldValues = {} as ReportValues
        this.fields = {}
        this.activeTab = ''
        this._isValid = false
        this.dispatchEvent(
            new CustomEvent('report-modal-close', {
                bubbles: true,
                composed: true,
            }),
        )
        this._isLoading = false
        this.open = false
    }
    private _handleCloseReportSubmit() {
        this._handleClose()
        WeatherRoutingModel!.dispatchEvent(
            new CustomEvent(SHOW_MINIMIZED_REPORT, {
                detail: {
                    ...this.showMinimizePopUp,
                    minimizedPopUp: true, // false means show the minimized notification
                },
            }),
        )
    }

    
    private _handleInput(event: Event, item: ReportField): void {
        const input = event.target as HTMLInputElement
        const value = input.value
        
        this._fieldValues[item.fieldName].value = value;
        this._fieldValues[item.fieldName].invalid = this._handleInvalid(item)
        this._fieldValues[item.fieldName].change = true
        if(item.fieldName === "wind_speed"){
            this._fieldValues['wind_speed'].value = value === '' ? 0 : getParsedValue(value) ? parseInt(value) : value
            this._fieldValues['wind_bf'].value = getWindBF(value === '' ? 0 : parseInt(value))
            this._fieldValues["wind_bf"].invalid = false
            this._fieldValues["wind_bf"].change = true
        }
        if (this._handleInvalid(item)) {
            this._isValid = true
        } else {
            this._isValid = false
        }
        this.requestUpdate()
    }

    private _handleInvalid(item: ReportField): boolean {
        const currentValue = this._fieldValues[item.fieldName]?.value ?? ''
        const isEmpty =
            currentValue === '' || currentValue === null

        let errorMessage = item.required && isEmpty ? 'required' : ''
        if (errorMessage === '') {
            errorMessage = validations(item, currentValue, errorMessage)
        }
        this._fieldValues[item.fieldName] = {
            ...this._fieldValues[item.fieldName],
            errorMessage,
        }
        return errorMessage !== ''
    }

    private _getDropdownData(fieldName: string) {
        switch (fieldName) {
            case 'report_type_repo': // report_type_repo
                return this.dropdownforReports.reportTypeRepo
            case 'dep_port_code_voyage':
            case 'arr_port_code_voyage': // arr_port_code
                return this.dropdownforReports.reportWNI
            case 'swell_dir': // swell_dir
            case 'wind_dir': // wind_dir
            case 'windsea_dir': // windsea_dir
                return this.dropdownforReports.reportSwellDir
            case 'event':
                return this.dropdownforReports.event
            case 'loading_condition': // loading_condition
                return this.dropdownforReports.loadingCondition
            default:
                return []
        }
    }

    private async _handleTimeLtField(item: ReportField) {
        const rawValue: number | undefined = this.fieldValues.imo

        const scheduleData: ScheduleItem[] =
            await SchedulesService.fetchScheduleVesselStates(
                rawValue ? rawValue : null,
                'NowButton',
            )

        if (Object.entries(scheduleData).length > 0) {
            const data = Object.values(scheduleData[0])[0].portCall
                ? Object.values(scheduleData[0])[0].portCall
                : Object.values(scheduleData[0])[0].voyage
            const arrivalAt = data.arrivalAt
            const arrivalDate = new Date(arrivalAt)
            const departureAt = data.departureAt
            const departureDate = new Date(departureAt)
            const now = Date.now()
            const timeInMillisecondsArrival = arrivalDate.getTime()
            const timeInMillisecondsDeparture = departureDate.getTime()

            const timestampsAndTerminals = []
            if (
                Math.abs(now - timeInMillisecondsArrival) <
                Math.abs(now - timeInMillisecondsDeparture)
            ) {
                timestampsAndTerminals.push({
                    timestamp: new Date().toISOString(),
                    terminalId:
                        this.fieldValues?.metadata?.misc?.value
                            .arrivalTerminalCode,
                })
            } else {
                timestampsAndTerminals.push({
                    timestamp: new Date().toISOString(),
                    terminalId:
                        this.fieldValues?.metadata?.misc?.value
                            .departureTerminalCode,
                })
            }

            const conversionResult =
                await TerminalsModel!.getTerminalLocaltimeBatch(
                    timestampsAndTerminals.map((entry) => ({
                        timestamp: entry.timestamp,
                        terminalId: entry.terminalId || '',
                    })),
                )
            this._fieldValues[item.fieldName].value =
                conversionResult[0].substring(0, 16)
        }
    }

    private async _handleNowButtonClick(item: ReportField) {
        if (
            // time_lt, arr_ps_master_eta_lt
            item.fieldName === 'time_lt' ||
            item.fieldName === 'arr_ps_master_eta_lt'
        ) {
            await this._handleTimeLtField(item)
        } else {
            const now = new Date()
            this._fieldValues[item.fieldName].value = now
                .toISOString()
                .slice(0, 16)
        }

        this.requestUpdate()
    }

    private conditionallyShowValues(item: ReportField) {
        if (
            item.fieldName === 'arr_eosp_average_speed' ||
            item.fieldName === 'wind_speed' || 
            item.fieldName === 'nton_average_speed'
        ) {
            return 'kn'
        }
        if (
            item.fieldName === 'arr_eosp_steaming_distance' ||
            item.fieldName === 'visibility' || 
            item.fieldName === 'steaming_distance' || 
            item.fieldName === 'remaining_distance_to_ps' || 
            item.fieldName === 'sosp_eosp_total_distance'
        ) {
            return 'NM'
        }
        if (
            item.fieldName === 'gm' ||
            item.fieldName === 'dep_berth_draft_aft' ||
            item.fieldName === 'swell_height' ||
            item.fieldName === 'windsea_height' || 
            item.fieldName === 'dep_berth_draft_fore' ||
            item.fieldName === 'noon_draft_aft' ||
            item.fieldName === 'noon_draft_fore'
        ) {
            return 'm'
        }
        if (item.fieldName === 'arr_ps_requested_eta_margin') {
            return 'min'
        }
        if (
            item.fieldName === 'arr_eosp_steaming_hours' ||
            item.fieldName == 'steaming_hours' ||
            item.fieldName === 'sosp_eosp_total_hours'
            ) {
            return 'hrs'
        }
        return ''
    }

    private _decimalCoordsFromGPSFormat(
        event: Event,
        isLatitude: boolean = true,
        item: ReportField,
    ): void {
        const input = event.target as HTMLInputElement
        const value = input.value.trim()

        if (isLatitude) {
            try {
                const decimalValue =
                    CoordinateConverterReports.latitudeToDecimal(value)
                this._fieldValues[item.fieldName].value = decimalValue
                this._fieldValues[item.fieldName].formattedValue =
                    this._formatCoordinate(
                        decimalValue,
                        item.fieldName === 'lat',
                    )
                this._fieldValues[item.fieldName].change = true
            } catch (err) {
                this._fieldValues[item.fieldName].formattedValue = value
            }
        } else {
            try {
                const decimalValue =
                    CoordinateConverterReports.longitudeToDecimal(value)
                this._fieldValues[item.fieldName].value = decimalValue
                this._fieldValues[item.fieldName].formattedValue =
                    this._formatCoordinate(
                        decimalValue,
                        item.fieldName === 'lat',
                    )
                this._fieldValues[item.fieldName].change = true
            } catch (err) {
                this._fieldValues[item.fieldName].formattedValue = value
            }
        }
        this.requestUpdate()
    }

    private renderLatAndLonField(item: ReportField) {
        return html`
            <div
                class=${item.editable === 'readOnly' || this.disableValues
                    ? 'inputContainer disable-input'
                    : 'inputContainer'}
            >
                <input
                    id=${item.fieldName}
                    .value=${this._fieldValues[item.fieldName]?.formattedValue}
                    type="text"
                    ?disabled=${item.editable === 'readOnly' ||
                    this.disableValues}
                    @input=${(e: Event) =>
                        this._decimalCoordsFromGPSFormat(
                            e,
                            item?.fieldName === 'lat' || item.fieldName === 'arr_ps_lat',
                            item,
                        )}
                />
            </div>
        `
    }

    private _formatCoordinate(formattedValue: number, isLatitude: boolean = true): string {
        if (formattedValue == null) return '';
    
        const degrees = Math.floor(Math.abs(formattedValue));
        const minutesDecimal = (Math.abs(formattedValue) - degrees) * 60;
        const minutes = minutesDecimal.toFixed(3); // Keep minutes with 3 decimal places
    
        const direction = isLatitude
            ? formattedValue < 0 ? 'S' : 'N'
            : formattedValue < 0 ? 'W' : 'E';
    
        return `${degrees}\u00b0 ${minutes}\u2032 ${direction}`;
    }

    private RenderFieldValue(item: ReportField) {
        const isEditable = item.editable !== 'readOnly' || item.type === 'date'
        const itemType = `${item.type}-${isEditable ? 'editable' : 'readOnly'}`

        // Render separately for lat or lon fields
        if (item.fieldName === 'lat' || item.fieldName === 'lon' || item.fieldName === 'arr_ps_lat' || item.fieldName === 'arr_ps_lon') {
            return this.renderLatAndLonField(item)
        }

        switch (itemType) {
            case 'date-editable':
                return html`<div
                    class=${item.editable === 'readOnly' || this.disableValues
                        ? 'inputContainer disable-input'
                        : 'inputContainer'}
                    ?invalid=${this._handleInvalid(item)}
                >
                    <input
                        id=${item.fieldName}
                        type="datetime-local"
                        .value=${this._fieldValues[item.fieldName]?.value}
                        ?disabled=${item.editable === 'readOnly' ||
                        this.disableValues}
                        class=${item.editable === 'readOnly'
                            ? 'disable-input'
                            : ''}
                        @input=${(e: Event) => this._handleInput(e, item)}
                    />
                    ${item.editable !== 'readOnly' && !this.disableValues
                        ? html`<button
                              class="nowButton"
                              @click=${() => this._handleNowButtonClick(item)}
                          >
                              NOW
                          </button>`
                        : html``}
                </div>`
            case 'dropdown-editable': {
                const dropdownData = this._getDropdownData(item.fieldName)
                const validOptions = dropdownData.map(
                    (itemDropdown: { option: string }) => itemDropdown.option,
                )
                if (
                    !validOptions.includes(
                        this._fieldValues[item.fieldName]?.value,
                    )
                ) {
                    this._fieldValues[item.fieldName] = {
                        ...this._fieldValues[item.fieldName],
                        value: '',
                    }
                }
                const currentValue = this._fieldValues[item.fieldName]?.value

                return html`<div
                    class=${item.editable === 'readOnly' || this.disableValues
                        ? 'inputContainer disable-input'
                        : 'inputContainer'}
                    ?invalid=${this._handleInvalid(item)}
                >
                    <select
                        id=${item.fieldName}
                        class="dropdown"
                        .value=${currentValue}
                        @input=${(e: Event) => this._handleInput(e, item)}
                        ?disabled=${item.editable === 'readOnly' ||
                        this.disableValues}
                    >
                        <option value="">Select...</option>
                        ${dropdownData.map(
                            (itemDropdown: { option: string }) => {
                                return html`<option
                                    .value=${itemDropdown.option}
                                    ?selected=${currentValue ===
                                    itemDropdown.option}
                                >
                                    ${itemDropdown.option}
                                </option>`
                            },
                        )}
                    </select>
                </div>`
            }
            default:
                return html`<div
                    class=${item.editable === 'readOnly' || this.disableValues
                        ? 'inputContainer disable-input'
                        : 'inputContainer'}
                    ?invalid=${this._handleInvalid(item)}
                >
                    <input
                        id=${item.fieldName}
                        .value=${this._fieldValues[item.fieldName]?.value}
                        type="text"
                        ?disabled=${item.editable === 'readOnly' ||
                        this.disableValues}
                        @input=${(e: Event) => this._handleInput(e, item)}
                    /><span class="suffix"
                        >${this.conditionallyShowValues(item)}</span
                    >
                </div>`
        }
    }

    private _switchTab(tabId: string) {
        this.fieldValues = {} as ReportValues
        this._fieldValues = {}
        this.dispatchEvent(
            new CustomEvent('active-tab', {
                detail: { tabId: tabId },
                bubbles: true,
                composed: true,
            }),
        )
        // this will send id at the initial render
        if (tabId === 'noon') {
            this.dispatchEvent(
                new CustomEvent('noon-current-page', {
                    bubbles: true,
                    composed: true,
                    detail: {
                        currentPage: this.paginationIds[this.paginationIds.length-1],
                    },
                }),
            )
        }
        this.activeTab = tabId
        this.requestUpdate()
    }

    private _handleExpand() {
        WeatherRoutingModel!.dispatchEvent(
            new CustomEvent(SHOW_MINIMIZED_REPORT, {
                detail: {
                    ...this.showMinimizePopUp,
                    minimizedPopUp: false,
                },
            }),
        )
        this._handleSubmitAndSave(false)
        this._handleClose()
    }

    private renderTabs() {
        return html`
            <div class="tabs-container">
                <div class="tabs">
                    <!-- SOSP : Departure Report -->
                    <button
                        class="tab ${this.activeTab === 'sosp' ? 'active' : ''}"
                        @click=${() => this._switchTab('sosp')}
                    >
                        Report Details - SOSP
                    </button>
                    <button
                        class="tab ${this.activeTab === 'noon' ? 'active' : ''}"
                        @click=${() => this._switchTab('noon')}
                    >
                        Report Details - NOON
                    </button>
                    <!-- EOSP : Arrival Report -->
                    <button
                        class="tab ${this.activeTab === 'eosp' ? 'active' : ''}"
                        @click=${() => this._switchTab('eosp')}
                    >
                        Report Details - EOSP
                    </button>
                </div>
                ${this.activeTab === 'noon'
                    ? html`<div class="pagination-container">
                          <mc-pagination
                              totalpages=${this.paginationIds.length}
                              currentpage=${this.currentPage}
                              @pagechange=${(e: CustomEvent) => {
                                  this.currentPage = e.detail
                                  this.dispatchEvent(
                                      new CustomEvent('noon-current-page', {
                                          bubbles: true,
                                          composed: true,
                                          detail: {
                                              currentPage: this.paginationIds[e.detail - 1],
                                          },
                                      }),
                                  )
                              }}
                          >
                          </mc-pagination>
                      </div>`
                    : html``}
                <div class="expand-container" @click=${this._handleExpand}>
                    ${SvgIcons.expand}
                </div>
            </div>
        `
    }

    private renderField() {
        return Object.entries(this._fieldValues).length > 0 &&
            Object.entries(this.fields).length > 0
            ? html`${Object.entries(this.fields['tab1']).map(
                  ([groupName, fields]) => {
                      return html`
                          <div class="each-row-according-to-group">
                              <div class="group-name">${groupName}</div>
                              <div class="whole-container">
                                  ${fields?.map((item) => {
                                      return html` <div class="field-container">
                                          <label
                                              class="field-label"
                                              for=${item.fieldName}
                                              >${item.label}${isRequired(
                                                  item.required,
                                              )}
                                              ${this.fieldValues?.metadata[
                                                  item?.fieldName as MetaDataKeys
                                              ]?.isSystemGenerated
                                                  ? html`<span
                                                        class="system-generated-styles"
                                                        >System</span
                                                    >`
                                                  : html``}</label
                                          >
                                          ${this.RenderFieldValue(item)}
                                          <span class="error-message"
                                              >${this._fieldValues[
                                                  item.fieldName
                                              ]?.errorMessage}</span
                                          >
                                      </div>`
                                  })}
                              </div>
                          </div>
                      `
                  },
              )}`
            : this._isLoading
            ? html`<div class="loadingOverlay">
                  <voyage-spinner></voyage-spinner>
              </div>`
            : NoData()
    }

    private createReport(reportType: string) {
        this.dispatchEvent(new CustomEvent(`create-${reportType}-report`))
    }


    render() {
        if (!this.open) {
            return html``
        }

        const submittedReport = this.fieldValues?.status === 'closed' || this.fieldValues?.status === 'submitted';

        return html`
            <div class="modal-container">
                <mc-modal
                    ?hiddenclose=${true}
                    ?open=${this.open}
                    height="95vh"
                    width="90vw"
                    fit="medium"
                    dimension="large"
                    backdropcloseactiondisabled
                    escapecloseactiondisabled
                    entercloseactiondisabled
                >
                    ${this.renderTabs()}
                    ${this.errorOrEmpty
                ? html`
                      <div class="center-img-no-data">
                          <img src="./assets/images/noData.svg" />  
                      </div>
                      ${this.activeTab === 'eosp' || this.activeTab === 'noon'
                          ? html`
                                <mc-button
                                    slot="secondaryAction"
                                    appearance="primary"
                                    fit="medium"
                                    @click=${() => this.createReport(this.activeTab)}
                                >
                                    Create
                                </mc-button>
                            `
                          : nothing}
                  `
                        : html`
                              ${(() => {
                                  const isClosedEosp = this.activeTab === 'eosp' && this.fieldValues.status === 'closed';
                                  const spanColor = isClosedEosp ? '#D32F2F' : '#333333';
                                  const spanText = isClosedEosp ? 'EOSP report has been auto submitted.' : 'Please review the report details below and submit it.';
                                  return html`
                                      <span class="para-styles" style="color: ${spanColor}">
                                          ${spanText}
                                      </span>
                                  `;
                              })()}
                              ${!this._isLoading
                                  ? html`<div class="tab-content visible">
                                            ${this.renderField()}
                                        </div>
                                        <mc-button
                                            slot="primaryAction"
                                            appearance="neutral"
                                            variant="filled"
                                            ?disabled=${this._isValid || submittedReport}
                                            @click=${() =>
                                                this._handleSubmitAndSave(true)}
                                            fit="medium"
                                        >
                                            Submit
                                        </mc-button>
                                        ${this.activeTab === 'noon' && this.canCreateNoonReport ? 
                                            html`
                                                <mc-button
                                                    slot="primaryAction"
                                                    appearance="primary"
                                                    @click=${() =>
                                                        this.createReport('noon')}
                                                    fit="medium"
                                                >
                                                    Create
                                                </mc-button>
                                            `
                                            : nothing}`
                                  : html`<div class="loadingOverlay">
                                        <voyage-spinner></voyage-spinner>
                                    </div>`}
                          `}
                </mc-modal>
            </div>
        `
    }
}
